'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.formatLineItemIds = formatLineItemIds;
exports.couponCodeError = couponCodeError;
exports.lineItemStockError = lineItemStockError;
exports.handleErrors = handleErrors;
exports.handleChipSwitch = handleChipSwitch;
exports.handlePaymentRedirect = handlePaymentRedirect;

var _camelize = require('camelize');

var _camelize2 = _interopRequireDefault(_camelize);

var _order = require('../actions/order');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOOP = function NOOP() {};

function formatLineItemIds(order) {
  if (!order.line_items_attributes) {
    return {};
  }

  return order.line_items_attributes.reduce(function (previous, current) {
    var inputType = current.quantity === '+more' ? 'input' : 'select';

    previous[current.id] = inputType;

    return previous;
  }, {});
}

function getErrorMessage(body) {
  var isUsingFlashFormat = body.flash && body.flash.message;

  if (isUsingFlashFormat) return body.flash.message;

  // return the whole object for line item errors
  if (body.lineItemId && body.message) return body;

  // localized error message from platform (solidus)
  if (body.message) return body.message;

  return body.error;
}

function couponCodeError(body) {
  return { coupon_code_error_message: getErrorMessage(body) };
}

function lineItemStockError(body) {
  return body;
}

function defaultErrorMessage(body) {
  return { message: getErrorMessage(body), messages: (0, _camelize2.default)(body.errors) };
}

function handleErrors(promise) {
  var dispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP;
  var errorMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultErrorMessage;

  return new _promise2.default(function (accept, reject) {
    promise.then(accept, function (error) {
      function handleError(body) {
        reject(errorMessage(body));
      }

      if (error.response) {
        if (error.response.status === 401) {
          dispatch((0, _order.orderClose)());
          reject({
            message: 'We’re sorry, but there was an error with your cart and we’ve had to empty it'
          });
        } else {
          error.response.json().then(handleError).catch(function () {
            console.error('Error: ', error);
          });
        }
      } else {
        console.error(error);
        reject({ message: 'Sorry we encountered an error, please try again' });
      }
    });
  });
}

function handleChipSwitch(promise) {
  var dispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOOP;
  var id = arguments[2];
  var order = arguments[3];

  return new _promise2.default(function (accept, reject) {
    promise.then(function () {
      accept(dispatch((0, _order.lineItemRemove)(id)));
    }, function (error) {
      if (error.response) {
        error.response.json().then(function (body) {
          order.error = body;
          reject(body);
        }).catch(function () {
          console.error('Error: ', error);
        });
      } else {
        console.error(error);
        reject({ message: 'Sorry we encountered an error, please try again' });
      }
    });
  });
}

function handlePaymentRedirect(response) {
  return response.then(function (res) {
    if (res.order && res.order.paymentUrl) {
      window.location.assign(res.order.paymentUrl);
    }

    return res;
  });
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/actions.js
// module id = 148
// module chunks = 0